export default "__VITE_ASSET__d0b22731__"